import { createContext, useContext, useMemo } from 'react';
import { useSearch } from '@/shared/hooks';
import * as Activities from '@pkg/entities/library/activities';

export const ActivityContext = createContext();
export const useActivityContext = () => useContext(ActivityContext);

const ActivityProvider = ({ children }) => {
  const activityMap = Activities.useStore((state) => state.mapped);
  const activityList = Activities.useStore((state) => state.list);
  const activityIndex = Activities.useStore((state) => state.index);
  const setActivities = Activities.useStore((state) => state.setActivities);

  const searchActivities = useSearch({
    searchList: activityList,
    searchMap: activityMap,
    searchIndex: activityIndex,
  });

  const search = (searchTerm, validationFn) => {
    return searchActivities(searchTerm, validationFn);
  };

  /**
   * Updates the activity index with the provided activity list.
   *
   * @param {Array}
   */
  const updateActivityIndexes = (activities) => {
    setActivities(activities);
  };

  const context = useMemo(() => {
    return {
      search,
      activityList,
      activityMap,
      updateActivityIndexes,
    };
  }, [activityList, activityMap]);

  return (
    <ActivityContext.Provider value={context}>
      {children}
    </ActivityContext.Provider>
  );
};

export default ActivityProvider;
